import { PayloadAction } from '@reduxjs/toolkit';
import { UpdateAddressDetailsPayload } from './types';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getBeneficiaryDetails,
  getInsuredDetails,
  refreshContactList,
} from '@/features/entityDetails/store/entityDetailsSlice';
import { resetAddressValidationState } from '@/features/googleApi/addressValidationApi/store/googleAddressValidationApiSlice';
import { resetGooglePlacesState } from '@/features/googleApi/placesApi/store/googlePlacesApiSlice';
import { Modals } from '@/features/serviceModal/enums/Modals';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { setSystemLoadingStatus } from '@/features/system/store/systemSlice';
import AddressEvents from '@/domains/addresses/events';
import { AddressHoldersEnum } from '@/enums/AddressHoldersEnum';
import EventService from '@/services/EventService/EventService';
import HttpService from '@/services/HttpService/HttpService';
import ModalService from '@/services/ModalService/ModalService';
import { default as SnackService, default as SnacksService } from '@/services/SnackService/SnackService';
import { updateAddressDetails } from '../store/addressesSlice';

function* updateAddressDetailsSaga({ payload }: PayloadAction<UpdateAddressDetailsPayload>) {
  const { addressId, addressHolder, addressHolderId, address } = payload;

  try {
    yield put(setSystemLoadingStatus(true));

    yield call(HttpService.patch, `/examiner/address/update/${addressId}`, address);
    SnacksService.add({
      type: SnackType.Success,
      title: 'Updates saved successfully!',
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom',
      },
    });

    EventService.dispatch(new AddressEvents.Edited({}));

    switch (addressHolder) {
      case AddressHoldersEnum.Beneficiary: {
        yield put(getBeneficiaryDetails({ beneficiaryId: String(addressHolderId) }));
        break;
      }
      case AddressHoldersEnum.Insured: {
        yield put(getInsuredDetails({ insuredId: String(addressHolderId) }));
        break;
      }
      case AddressHoldersEnum.Contact: {
        yield put(refreshContactList());
        break;
      }
    }
  } catch (error) {
    console.error(error);
    SnackService.add({
      type: SnackType.Error,
      title: 'Failed to save the update',
      content: 'Please try again',
      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    });
  } finally {
    yield put(setSystemLoadingStatus(false));
    yield put(resetAddressValidationState());
    yield put(resetGooglePlacesState());
    ModalService.close(Modals.UpdateAddress);
  }
}

export function* addressWatcher() {
  yield takeLatest(updateAddressDetails.type, updateAddressDetailsSaga);
}
